import { Button, Meta, theme } from 'aimo-ui';
import useAfterAuthenticationRedirect from 'hooks/useAfterAuthenticationRedirect';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';

const ItemRow = styled.Pressable`
  flex-direction: row;
  padding: 10px 20px 10px 25px;
  justify-content: space-between;
  background-color: ${theme.colors.gray50};
  border-radius: 10px;
  margin-bottom: 20px;
  align-items: center;
`;

const ButtonWrapper = styled.View`
  margin-left: 15px;
`;

const TextWrapper = styled.View`
  flex-direction: column;
  flex-shrink: 1;
`;

const GoToSignIn: React.FC = () => {
  const { t } = useTranslation();
  const { navigateToAuthentication, setReturnToMainPage } =
    useAfterAuthenticationRedirect();

  const handleOnPress = async () => {
    setReturnToMainPage();
    await navigateToAuthentication();
  };

  return (
    <ItemRow
      accessible={true}
      accessibilityRole="button"
      onPress={handleOnPress}
      testID="parking-to-sign-in">
      <TextWrapper>
        <Meta testID="to-sign-in-text">
          {t('parking.notSignedIn.description')}
        </Meta>
      </TextWrapper>
      <ButtonWrapper>
        <Button
          text={t('parking.notSignedIn.button.short')}
          testID="to-sign-in-button"
          buttonType="primary"
          size="s"
          onPress={handleOnPress}
          accessible={false}
          accessibilityLabel={t('parking.notSignedIn.button.short')}
        />
      </ButtonWrapper>
    </ItemRow>
  );
};

export default GoToSignIn;
